import loadable from '@loadable/component';

export const ResetPasswordPageContainerLoadable = loadable(
  () => import('./ResetPasswordPageContainer'),
  { resolveComponent: (module) => module.ResetPasswordPageContainer },
);
